export interface EventGroup<T> {
    key: string;
    label: string;
    date: string;
    items: T[];
}

export interface GroupedByEvent<T> {
    groups: EventGroup<T>[];
    ungrouped: T[];
}

// Regroupe des lignes par privatisation — extrait de ExtrasModule.tsx/ExtrasPartnerRequestsPage.tsx (où
// cette même fonction était dupliquée à l'identique), généralisé via un callback pour être réutilisable par
// StatusTrackingTable quel que soit le type de ligne. Une ligne sans groupe (getGroup renvoie null) reste
// affichée seule, hors groupe.
export function groupByEvent<T>(entries: T[], getGroup: (item: T) => { key: string; label: string; date: string } | null): GroupedByEvent<T> {
    const groups: EventGroup<T>[] = [];
    const byKey = new Map<string, EventGroup<T>>();
    const ungrouped: T[] = [];
    entries.forEach((item) => {
        const g = getGroup(item);
        if (!g) { ungrouped.push(item); return; }
        if (!byKey.has(g.key)) {
            const group: EventGroup<T> = { key: g.key, label: g.label, date: g.date, items: [] };
            byKey.set(g.key, group);
            groups.push(group);
        }
        byKey.get(g.key)!.items.push(item);
    });
    return { groups, ungrouped };
}
